module.exports = __webpack_public_path__ + "static/2-eb98893444796456691b0fa5030ebfc9.png";